import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import { createFileRoute } from '@tanstack/react-router';

import { LoginDenialScreen } from '#components/login-denial-screen/login-denial-screen.js';
import { LoginDenialTone } from '#components/login-denial-screen/login-denial-tone.js';

export const Route = createFileRoute('/_authorization-gate/work-email-required/')({
	head: () => ({ meta: [{ title: 'Work email required • Cadstrom' }] }),
	component: WorkEmailRequiredPage,
});

/**
 * Landing screen for a login denied because the account uses a personal email
 * address. Reached when the Auth0 Post-Login gate denies with the
 * `work_email_required` code (see auth0-callback-page.tsx).
 */
export function WorkEmailRequiredPage() {
	return (
		<LoginDenialScreen
			icon={<BusinessCenterOutlinedIcon className='text-[1.375rem]' />}
			tone={LoginDenialTone.Warning}
			title='Work email required'
			message='Personal email addresses can’t be used. Log in with your work email instead.'
			loginLabel='Log in with another account'
			forceReauthentication
		/>
	);
}
